import {ErrorMessages} from 'constants/Errors';
import {SuccessMessages} from 'constants/Success';

import {AxiosResponse} from 'axios';
import {call, put} from 'redux-saga/effects';
import {updateUserProfile} from 'services/profile-service';
import {setSuccessAC, setUserAC} from 'store/app/appSlice';
import {handleError} from 'store/app/error/saga';
import ApiData from 'typescript/interfaces/ApiData';
import User from 'typescript/models/User';

import {setProfileInfoAC} from '../profileSlice';
import {updateUserInfoACS} from '../requestAC';

export function* updateUserInfo(action: ReturnType<typeof updateUserInfoACS>) {
  const user = localStorage.getItem('user');
  let userId;

  if (user) userId = JSON.parse(user).id;

  try {
    const response: AxiosResponse<ApiData<User>> = yield call(updateUserProfile, action.payload!, userId);
    const userData = response.data.data;

    localStorage.setItem('user', JSON.stringify(userData));
    yield put(setProfileInfoAC(userData.attributes));
    yield put(setUserAC(userData));
    yield put(setSuccessAC(SuccessMessages.UPDATE_USER_INFO));
  } catch (error) {
    yield call(handleError, error, ErrorMessages.PROFILE_INFO);
  }
}
